import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ngx-wysiwyg-md-editor',
  template: `
    <p>
      ngx-wysiwyg-md-editor works!
    </p>
  `,
  styles: []
})
export class NgxWysiwygMdEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
